import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ItemOrcamento } from 'src/app/admihair/api/dto/item-orcamento';
import { Orcamento } from 'src/app/admihair/api/dto/orcamento';
import { OrcamentoService } from 'src/app/admihair/service/orcamento.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { NgForm } from '@angular/forms';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { ItemServicoService } from 'src/app/admihair/service/item-servico.service';
import { Table } from 'primeng/table';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { ItemOrcamentoService } from 'src/app/admihair/service/item-orcamento.service';

@Component({
  selector: 'app-orcamentos-e-pacotes-editar',
  templateUrl: './orcamentos-e-pacotes-editar.component.html',
  styleUrls: ['./orcamentos-e-pacotes-editar.component.scss']
})
export class OrcamentosEPacotesEditarComponent extends AdmihairBaseComponent implements OnInit {

  progressoRequisicao: boolean = false;
  exibirDialogItem: boolean = false;
  exibirSpinnerDialogItem: boolean = false;
  listaItensDialog: any[] = [];

  loadingTable: boolean = false;
  loadingClientes: boolean = false;
  exibirDialogCliente: boolean = false;
  exibirSpinnerDialogCliente: boolean = false;
  listaClientes: Cliente[] = [];
  itensClientesPaginados?: Paginador<Cliente>;
  numeroPaginaCliente: number = 0;
  inputBusca?: string = '';

  
  id?: number;
  orcamento?: Orcamento;
  listaItensOrcamento: ItemOrcamento[] = [];
  tiposOrcamento: SelectItem[] = [
    {label: 'ORÇAMENTO', value: 'ORCAMENTO'},
    {label: 'PACOTE', value: 'PACOTE'}
  ];
  tipoOrcamentoSelecionado?: string;
  valorDataOrcamento?: Date;

  tiposItem: SelectItem[] = [{ label: 'Serviço', value: 4 }, { label: 'Produto', value: 3 }];
  tipoItemSelecionado: number = 4;
  valorTotalItens: number = 0;

  @ViewChild('f') form?: NgForm;
  @ViewChild('filter') filter!: ElementRef;

  constructor(private orcamentoService: OrcamentoService,
    private itemOrcamentoService: ItemOrcamentoService,
    private clienteService: ClienteService,
    private itemProdutoService: ItemProdutoService,
    private itemServicoService: ItemServicoService,
    private confirmationService: ConfirmationService,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService);
  }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_ORCAMENTOS_E_PACOTES');
    this.carregarIdOrcamento();
    if (this.permissaoEditar) {
      this.carregarOrcamento();
    }
  }

  carregarIdOrcamento() {
    const idParam = this._activatedRoute.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }

  carregarOrcamento() {
    this.orcamentoService.buscarPorId(this.id).subscribe({
      next: (data: Orcamento) => {
        this.orcamento = data;
        if(data.dataOrcamento) {
          this.valorDataOrcamento = new Date(data.dataOrcamento)
        }
        this.listaItensOrcamento = data.listaItens ?? [];
        this.tipoOrcamentoSelecionado = data.tipo;
        this.calcularValorTotal();
        this.setExibirSpinnerPrincipal(false);
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  atualizar() {
    if(this.orcamento) {
      this.progressoRequisicao = true;
      const tipoAnterior = this.orcamento.tipo;
      this.orcamento.tipo = this.tipoOrcamentoSelecionado;
      this.orcamento.listaItens = this.listaItensOrcamento;
      this.orcamentoService.atualizar(this.orcamento).subscribe({
        next: (data: Orcamento) => {
          this.orcamento = data;
          this.progressoRequisicao = false;
          this.exibirMensagemSucesso();
        },
        error: (err: any) => {
          if(this.orcamento)
            this.orcamento.tipo = tipoAnterior;
          this.progressoRequisicao = false;
          this.exibirMensagemErro(err);
        }
      })
    }
  }

  abrirDialogCliente() {
    this.exibirSpinnerDialogCliente = true;
    this.exibirDialogCliente = true;
    this.carregarClientes(0);
  }

  carregarClientes(numPagina: number) {
    const status = true;
    const ordernacao = 'nome,acs';
    const tamanhoPagina = 5;
    this.clienteService.listarClientesPorEmpresaESituacaoETextoBuscaPaginado(this.getEmpresa().id, status,
      numPagina, tamanhoPagina, ordernacao, this.inputBusca).subscribe({
        next: (data: Paginador<Cliente>) => {
          this.itensClientesPaginados = data;
          this.listaClientes = data.content;
          this.loadingTable = false;
          this.exibirSpinnerDialogCliente = false;
        },
        error: (err: any) => {
          this.loadingTable = false;
          this.exibirSpinnerDialogCliente = false;
          this.exibirMensagemErro(err)
        }
      });
  }

  selecionarCliente(cliente: Cliente) {
    if(this.orcamento) {
      this.orcamento.interessado = cliente;
    }
    this.exibirDialogCliente = false;
  }

  onPageChangeCliente(event: any) {
    this.loadingTable = true;
    if (this.itensClientesPaginados) {
      this.numeroPaginaCliente = (event.first + event.rows) / this.itensClientesPaginados.size;
    }
    this.carregarClientes(this.numeroPaginaCliente - 1);
  }

  buscarDialogCliente(event: Event) {
    this.loadingTable = true;
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.carregarClientes(0);
  }

  limparDialogCliente() {
    this.loadingTable = true;
    this.filter.nativeElement.value = '';
    this.inputBusca = '';
    this.carregarClientes(0);
  }

  abrirDialogItem() {
    this.exibirDialogItem = true;
    this.exibirSpinnerDialogItem = true;
    this.carregarItens();
  }

  carregarItens() {
    const status = true;
    const idEmpresa = this.getEmpresa().id;
    if (this.tipoItemSelecionado === 4) {
      this.itemServicoService.listarPorEmpresaIdESituacao(idEmpresa, status).subscribe({
        next: (data: ItemServico[]) => {
          this.listaItensDialog = data.filter(itemServico =>
            !this.listaItensOrcamento.some(itemOrcamento =>
              itemOrcamento.itemId === itemServico.id)
            );
            this.exibirSpinnerDialogItem = false;
        },
        error: (err: any) => {
          this.exibirSpinnerDialogItem = false;
          this.exibirMensagemErro(err);
        }
      });
    } else if (this.tipoItemSelecionado === 3) {
      this.itemProdutoService.listarProdutoVendaPorEmpresaId(idEmpresa).subscribe({
        next: (data: ItemProduto[]) => {
          this.listaItensDialog = data.filter(itemProduto =>

            !this.listaItensOrcamento.some(itemOrcamento =>
              itemOrcamento.itemId === itemProduto.id)
            );
          this.exibirSpinnerDialogItem = false;
        },
        error: (err: any) => {
          this.exibirSpinnerDialogItem = false;
          this.exibirMensagemErro(err);
        }
      });
    }
  }


  adicionarItem(item: any) {
    this.listaItensOrcamento.push({
      itemId: item.id,
      nomeItem: item.descricao,
      quantidadeProposta: 1,
      valorUnitario: item.valorVenda,
      descontoItem: 0
    });
    this.exibirDialogItem = false;
    this.calcularValorTotal();
  }

  calcularValorTotal() {
    this.valorTotalItens = 0;
    for(let item of this.listaItensOrcamento) {
      this.valorTotalItens += this.calcularValorTotalItem(item);
    }
    this.calcularValorProposta();
  }

  calcularValorTotalItem(item: ItemOrcamento): number {
    const desconto = item.descontoItem ?? 0;
    const quantidade = item.quantidadeProposta ?? 1;
    const valorUnitario = item.valorUnitario ?? 0;

    const valorComDesconto = valorUnitario - (valorUnitario * (desconto / 100));
    return valorComDesconto * quantidade;
  }

  calcularValorProposta(){
    
    if(this.orcamento?.valorProposta){
      let valorPropostaCalculado = 0;
      const descontoAplicado = (this.orcamento.desconto ?? 0) / 100;
      valorPropostaCalculado += this.valorTotalItens - (this.valorTotalItens * descontoAplicado);
      this.orcamento.valorProposta = valorPropostaCalculado;
    }
  }


  excluirItemOrcamento(idItem: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.itemOrcamentoService.excluir(idItem).subscribe({
          next: () => {
            this.carregarOrcamento();
            this.exibirMensagemSucesso();
          },
          error: (err: any) =>{
            this.exibirMensagemErro(err);
          } 
        });
      }
    });
    
  }


  habilitadoEditar(): boolean {
    if(this.orcamento?.tipo === 'PACOTE' && this.orcamento.status === 'PAGO') {
      return false;
    }
    return this.permissaoEditar;
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  ocultarMensagem() {
    if (this.messagemVisivel) {
      this.messagemVisivel = false;
    }
  }


}
